import React from "react";
import moment from "moment";
import 'moment/locale/pt-br';
import NumberFormat from "react-number-format";

function moneyMask(value) {
  return (
    <NumberFormat
      decimalSeparator=","
      thousandSeparator="."
      decimalScale={2}
      prefix="R$ "
      displayType={'text'}
      value={value !== undefined && value}
    />
  )
}

function percentMask(value) {
  return (
    <NumberFormat
      decimalSeparator=","
      thousandSeparator="."
      decimalScale={2}
      suffix="%"
      displayType={'text'}
      value={value !== undefined && value}
    />
  )
}

export default function DashboardConsorcioHistorico({ data }) {
  moment.locale('pt-br');
  return (
    <>
      <div className="flex flex-col gap-3 bg-white h-full rounded-lg drop-shadow p-5">
        <h2 className="text-2xl font-bold text-gray-600 mb-2 truncate">
          Histórico de economia
        </h2>
        <div className="flex flex-col gap-4">
          {data && data.map(({ mesReferencia, economia, percentualEconomia }) => (
            <div className="flex justify-between items-center">
              <div>
                <h3 className="text-base font-semibold text-gray-600">
                  {moment(mesReferencia).format("MMMM/yy")}
                </h3>
                <p className="text-sm font-normal text-gray-500">% de economia</p>
              </div>
              <div className="flex flex-col justify-end items-end">
                <h3 className="text-base font-bold text-gray-600">{moneyMask(economia)}</h3>
                <div className="flex items-center gap-1">
                  <span className="text-sm font-semibold text-gray-500">
                    {percentMask(percentualEconomia)}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
